import React from 'react'
import Link from '../utils/link'

const AgentFullWidthButton = ({ button }) => (
  <section className='agent-full-width-button'>
    <div className='agent-full-width-button__inner'>
      { button?.url && <Link className='btn' to={button.url}>{button.title}</Link> }
    </div>
  </section>
)

AgentFullWidthButton.defaultProps = {
  button: {
    title: 'Book your free appraisal',
    url: '#contact-form'
  }
}

export default AgentFullWidthButton